export default "__VITE_ASSET__yUBGS$NA__"